import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '@core/services/app.service';
import { ConfirmService } from '@core/services/confirm.service';
import { ModalController } from '@ionic/angular';
import { ITalepler } from '@models/dashboard';

@Component({
  selector: 'app-demands-edit',
  templateUrl: './demands-edit.component.html',
  styleUrls: ['./demands-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandsEditComponent implements OnInit {
  @Input() talep: ITalepler;

  public talepEditForm: FormGroup;

  constructor(
    public app: AppService,
    private formBuilder: FormBuilder,
    private modalController: ModalController,
    private confirmService: ConfirmService
  ) { }

  ngOnInit(): void {
    this.editTalepBuildForm();
  }

  editTalepBuildForm() {
    this.talepEditForm = this.formBuilder.group({
      talepNo: [this.talep.talepNo, Validators.required],
      tarih: [new Date(this.talep.tarih).toJSON(), Validators.required],
      bolumNo: [this.talep.bolumNo, Validators.required],
      talepDurumu: [this.talep.talepDurumu, Validators.required],
      aciklama: [this.talep.aciklama, Validators.required]
    });
  }

  saveForm() {
    let talepEditModel = Object.assign({}, this.talepEditForm.value);
    this.modalController.dismiss({
      dismissed: true,
      talepEditModel
    });
  }

  // async dismiss(dismissed: boolean) {
  //   await this.modalController.dismiss(dismissed);
  // }

  dismiss() {
    if (this.talepEditForm.dirty) {
      this.confirmService.confirm({
        header: 'Global.ConfirmEdit.Header', subHeader: 'Global.ConfirmEdit.SubHeader',
        backdropDismiss: false,
        buttons: [{
          handler: () => {
            
          },
          text: 'Global.No',
          role: '',
          cssClass: 'text-dark'
        }, {
          handler: () => {
            this.modalController.dismiss({
              dismissed: false
            });
          },
          text: 'Global.Yes',
          role: 'cancel',
          cssClass: 'text-dark'
        }]
      });
      console.log('kirlendi');
    } else {
      this.modalController.dismiss({
        dismissed: false
      });
      console.log('kirlenmedi');
    }
  }
}
